var requestAnimFrame = (function () {
    return window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (callback) {
            window.setTimeout(callback, 1000 / 60);
        };
})();
export default class ImageScroller {
    constructor(images) {
        this.step = 1; // visible frame
        this.targetStep = 1; // frame to animate to
        this.images = new Array(); // stores all of the frames for quick access
        this.scrollPos = 1; // scroll position of the window
        this.totalFrames = 102; // the number of images in the sequence of JPEG files (this could be calculated server-side by scanning the frames folder)
        this.el = document.getElementById('video');
        this.images = images;
        this.totalFrames = this.images.length;
        this.resizeAdjustments(); // adjust the size of video placeholder image to fit the screen and keep aspect ratio (zoom crop)
        this.animloop();
    }
    animloop() {
        requestAnimFrame(() => {
            return this.animloop();
        });
        var targetStep = Math.max(Math.round(this.getYOffset() / 16), 1); // what frame to animate to
        if (targetStep != this.step) {
            this.step += (targetStep - this.step) / 20;
        } // increment the step until we arrive at the target step
        this.changeFrame();
    }
    resizeAdjustments() {
        var html = document.querySelector('html');
        var body = document.body;
        var image_width = this.el.style.width.replace('px', '');
        var image_height = this.el.style.height.replace('px', '');
        var height_ratio = image_height / document.body.clientHeight;
        var width_ratio = image_width / document.body.clientWidth;
        var body_width = document.body.clientWidth;
        if (height_ratio < width_ratio) {
            this.el.style.top = 0;
            var difference = image_width - body_width; // calculate the difference we need to accomodate for
            if (document.body.clientWidth < image_width) {
                this.el.style.right = (difference / 2) * -1; // reposition the video image from the left
            }
            else {
                this.el.style.right = 0;
            }
        }
        else {
            this.el.style.right = 0;
            var difference = image_height - document.body.clientHeight; // calculate the difference we need to accomodate for
            if (document.body.clientHeight < image_height) {
                this.el.style.right = (difference / 2) * -1; // reposition the video image from the left
            }
            else {
                this.el.style.right = 0;
            }
        }
    }
    changeFrame() {
        var thisStep = Math.round(this.step); // calculate the frame number
        if (this.images.length > 0 && this.images[thisStep]) { // if the image exists in the array
            if (this.images[thisStep].complete) { // if the image is downloaded and ready
                if (this.el.src != this.images[thisStep].src) { // save overhead...?
                    this.el.setAttribute('src', this.images[thisStep].src); // change the source of our placeholder image
                    this.currentImage = this.images[thisStep].src;
                }
            }
        }
    }
    getYOffset() {
        var pageY;
        if (typeof (window.pageYOffset) == 'number') {
            pageY = window.pageYOffset * 0.45; // Adjust imagescroll speed
        }
        else {
            pageY = document.documentElement.scrollTop * 0.45; // Adjust imagescroll speed (IE)
        }
        return pageY;
    }
    pad(number, length) {
        var str = '' + number;
        while (str.length < length) {
            str = '0' + str;
        }
        return str;
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/components/HeroSection/ImageScroll.ts
// module id = null
// module chunks = 